export const liningContent = `<!DOCTYPE html>
<html lang="en">

<head>
    <meta charset="UTF-8">
    <meta name="viewport" content="width=device-width, initial-scale=1.0">
    <title>Document</title>
    <style>
        .type-of-fold .heading {
            margin-bottom: 30px;
        }

        .type-of-fold .heading h4 {
            font-size: 20px;
            padding: 0 0 16px;
        }

        .type-of-fold .row {
            display: grid;
            grid-template-columns: repeat(3, 1fr);
            gap: 40px;
        }

        .type-of-fold-item h5 {
            margin: 0 0 24px;
            font-size: 18px;
        }

        .type-of-fold-item img {
            width: 100%;
            vertical-align: middle;
            height: auto;
            margin: 0 0 30px;
        }

        .type-of-fold-item p {
            margin: 0 0 16px;
        }

        .type-of-fold-item p:last-child {
            margin: 0;
        }

        .type-of-fold-item a {
            text-decoration: underline;
            color: inherit;
        }

        .type-of-fold .heading li {
            position: relative;
            list-style: none;
            padding: 0 0 0 24px;
            margin: 0;
        }

        .type-of-fold .heading ul {
            list-style: none;
            margin: 0;
            padding: 0;
        }

        .type-of-fold .heading li:before {
            content: "";
            background: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22" fill="none"><path d="M6 11L9.5 14.5L17.5 6.5" stroke="%234BAD3C" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>');
            position: absolute;
            top: 1px;
            width: 18px;
            height: 18px;
            background-size: 18px;
            left: 0;
        }

        .type-of-fold-item ul {
            margin: 0;
            padding: 0;
            list-style-position: inside;
        }

        .type-of-fold-item ul li {
            margin: 0 0 2px;
        }

        .type-of-fold-item ul li:last-child {
            margin: 0 0 2px;
        }

        @media (max-width: 767px) {
            .type-of-fold .row {
                grid-template-columns: 1fr;
            }
        }
    </style>
</head>

<body>
    <div class="type-of-fold">
        <div class="heading">
            <h4>Lining</h4>
            <p>Your can choose to have the back of the curtain covered with a lining. This way, you benefit from:</p>
            <ul>
                <li>Extra blackout</li>
                <li>Extra insulation</li>
                <li>Extra sound insulation</li>
                <li>Extra protection</li>
                <li>Luxurious appearance</li>
            </ul>
        </div>
        <div class="row">
            <div class="type-of-fold-item">
                <h5>Blockout lining</h5>
                <img src="https://cdn.shopify.com/s/files/1/0283/1053/6227/files/lining_1759322871040.jpg?v=1759753620" alt="Blockout lining">
                <p>Some curtains still let in little light. You can prevent this with a blackout lining. This makes the
                    bedroom extra dark.</p>
            </div>
            <div class="type-of-fold-item">
                <h5>Semi-Transparent lining</h5>
                <img src="https://cdn.shopify.com/s/files/1/0283/1053/6227/files/semitransperent_1759322871203.jpg?v=1759753620" alt="Semi-Transparent lining">
                <p>Want to enjoy the benefits of a lining, such as extra insulation, without completely darkening the
                    room? Choose a Semi-Transparent lining and still enjoy natural light.</p>
            </div>
            <div class="type-of-fold-item">
                <h5>No lining</h5>
                <img src="https://cdn.shopify.com/s/files/1/0283/1053/6227/files/nolining_1759322871087.jpg?v=1759753620" alt="No lining">
                <p>One of the advantages of a lining is extra blackout. Are you going for sheer curtains? Then you
                    naturally want to let in as much light as possible, so a lining isn't necessary.</p>
                <p>Available lining colours:</p>
                <ul>
                    <li>White</li>
                    <li>Beige</li>
                    <li>Gray</li>
                    <li>Taupe</li>
                    <li>Anthracite</li>
                </ul>
            </div>
        </div>
    </div>
</body>

</html>`;
